import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { R1DataUploadTable } from "./table";
import { R1DataUploadEdit } from "./edit";

export default function R1DataUpload() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Data upload");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<R1DataUploadEdit />} />
      <Route index element={<R1DataUploadTable />} />
    </Routes>
  );
}
